import { AfterViewInit, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { CountryName } from '../../../../assets/functions/get-country-name';
import { OnlyAcceptNumbers } from '../../../../assets/functions/only-accept-numbers';
import { ConstantsFordProtect } from '../../../models/constants/constants-ford-protect';
import { getPriceNameList, PriceName } from '../../../models/enum/price-name';
import { CoverageCategory } from '../../../models/product/coverage-category';
import { PriceDto } from '../../../models/product/price-dto';
import { ProductPolicyEditDto } from '../../../models/product/product-policy-edit';
import { ProductPolicyRequestDto } from '../../../models/product/product-policy-request';
import { ProductPolicyResponseDto } from '../../../models/product/product-policy-response';
import { ProductVisit } from '../../../models/product/product-visit';
import { VinCategory } from '../../../models/vin/vin-category';
import { ApsPermissionService } from '../../../services/aps-permission/aps-permission.service';
import { CoverageService } from '../../../services/coverage/coverage.service';
import { PriceService } from '../../../services/price/price.service';
import { ProductPolicyService } from '../../../services/product-policy/product-policy.service';
import { ProductService } from '../../../services/product/product.service';
import { VinService } from '../../../services/vin/vin.service';

type DropdownOption = {
  id: number | null;
  label: string;
};

type PriceDropdownOption = DropdownOption & {
  itemPriceUnit: string;
};

type DropdownSelection = DropdownOption | number | null;

type DropdownChangeEvent<T> = {
  value: T;
};

@Component({
  selector: 'app-eligibility-details-edit',
  templateUrl: './eligibility-details-edit.component.html',
  styleUrls: ['./eligibility-details-edit.component.scss'],
  standalone: false
})
export class EligibilityDetailsEditComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  listStatus = [
    { label: 'TRANSLATE.SELECT' },
    { label: 'TRANSLATE.ACTIVE', value: ConstantsFordProtect.COVERAGE_ACTIVE },
    { label: 'TRANSLATE.INACTIVE', value: ConstantsFordProtect.COVERAGE_INACTIVE }
  ];

  listYearVehicle = [
    { label: 'TRANSLATE.SELECT' },
    { label: 2017, value: 2017 },
    { label: 2018, value: 2018 },
    { label: 2019, value: 2019 },
    { label: 2020, value: 2020 },
    { label: 2021, value: 2021 },
    { label: 2022, value: 2022 },
    { label: 2023, value: 2023 },
    { label: 2024, value: 2024 },
    { label: 2025, value: 2025 },
    { label: 2026, value: 2026 },
    { label: 2027, value: 2027 },
    { label: 2028, value: 2028 },
    { label: 2029, value: 2029 }
  ];

  listSalesChannel = [
    { label: 'TRANSLATE.SELECT' },
    { label: 'TRANSLATE.DEALER', value: ConstantsFordProtect.DEALER },
    { label: 'TRANSLATE.TELEMARKETING', value: ConstantsFordProtect.TELEMARKETING }
  ];

  productPolicy: ProductPolicyEditDto = {} as ProductPolicyEditDto;
  id: number = 0;

  selectedProducts: DropdownOption | null = null;
  products: ProductVisit[] = [];
  idProduct: number = 0;
  placeholderProduct = 'TRANSLATE.SELECT';

  selectedCountry: string = '';
  country: string = '';

  selectedCoverages: DropdownOption | null = null;
  coverages: CoverageCategory[] = [];
  coveragesConcat: DropdownOption[] = [];
  idCoverage: number = 0;
  placeholderCoverage = 'TRANSLATE.SELECT';
  placeholderField = 'TRANSLATE.SELECT';

  selectCanalVenda: string = '';
  selectedStatus: number | null = 0;
  selectedYearVehicle: number = 0;
  year: number = 0;

  selectedVehicleLine: DropdownOption | null = null;
  vehicleLines: VinCategory[] = [];
  vehicleLineConcat: DropdownOption[] = [];
  idVehicle: number = 0;
  placeholderVehicle: string = '';

  selectedCustomerPrice: DropdownSelection = null;
  customersPrices: PriceDto[] = [];
  placeholderCustomerPrice: string = 'TRANSLATE.SELECT';
  placeholderWarranty: string = 'TRANSLATE.SELECT';
  placeholderSeller: string = 'TRANSLATE.SELECT';
  placeholderFordCost: string = 'TRANSLATE.SELECT';
  placeholderServiceCost: string = 'TRANSLATE.SELECT';
  priceName = PriceName.PRICE_CUSTOMER;
  idCustomerPrice: number | null = 0;
  idCostService: number | null = 0;
  idCostWarranty: number | null = 0;
  idSellerPrice: number | null = 0;
  idFordCost: number | null = 0;
  productPolicyRequestDto: ProductPolicyRequestDto = {} as ProductPolicyRequestDto;
  productPolicyResponseDto: ProductPolicyResponseDto = {} as ProductPolicyResponseDto;
  editedProductPolicy: ProductPolicyEditDto = {} as ProductPolicyEditDto;
  productArray: DropdownOption[] = [];
  selectDisabled: boolean = false;

  // Phase 1 Backup Arrays for Autocomplete Search
  allProductArray: DropdownOption[] = [];
  allCoveragesConcat: DropdownOption[] = [];
  allVehicleLineConcat: DropdownOption[] = [];

  // Phase 2 Backup Arrays for Price Fields Autocomplete Search
  allWarrantyPricesConcat: PriceDropdownOption[] = [];
  allServiceCostPricesConcat: PriceDropdownOption[] = [];
  allFordCostPricesConcat: PriceDropdownOption[] = [];
  allSellerPricePricesConcat: PriceDropdownOption[] = [];
  allCustomersPricesConcat: PriceDropdownOption[] = [];

  coverageCategoryId: number = 0;
  selectedYear: number | null = 0;
  selectedSalesChannel: number | null = 0;
  inputMonthsOffer: number | undefined | null = 0;
  inputPolicyDescription: string | undefined = '';
  blockedUi = false;
  countryNameResult: string = '';
  isEditingMode = false;
  hasAttemptedSave = false;

  selectedWarrantyCost: DropdownSelection = null;
  selectedServiceCost: DropdownSelection = null;
  selectedFordCostPrice: DropdownSelection = null;
  selectedSellerPrice: DropdownSelection = null;

  private _customersPricesConcat: PriceDropdownOption[] = [];
  private _warrantyCosts: PriceDropdownOption[] = [];
  private _serviceCosts: PriceDropdownOption[] = [];
  private _fordCosts: PriceDropdownOption[] = [];
  private _sellerPrices: PriceDropdownOption[] = [];

  private filterPricesByCountry(prices: PriceDropdownOption[]): PriceDropdownOption[] {
    if (!prices || prices.length === 0) {
      return [];
    }

    // Brasil uses only R$, other countries use only $
    const isBrazil = this.productPolicy?.country === ConstantsFordProtect.BRA;
    const targetCurrency = isBrazil ? 'R$' : '$';

    return prices.filter(price => price.itemPriceUnit === targetCurrency);
  }

  get customersPricesConcat(): PriceDropdownOption[] {
    return this.filterPricesByCountry(this._customersPricesConcat);
  }
  set customersPricesConcat(value: PriceDropdownOption[]) {
    this._customersPricesConcat = value;
  }

  get warrantyCosts(): PriceDropdownOption[] {
    return this.filterPricesByCountry(this._warrantyCosts);
  }
  set warrantyCosts(value: PriceDropdownOption[]) {
    this._warrantyCosts = value;
  }

  get serviceCosts(): PriceDropdownOption[] {
    return this.filterPricesByCountry(this._serviceCosts);
  }
  set serviceCosts(value: PriceDropdownOption[]) {
    this._serviceCosts = value;
  }

  get fordCosts(): PriceDropdownOption[] {
    return this.filterPricesByCountry(this._fordCosts);
  }
  set fordCosts(value: PriceDropdownOption[]) {
    this._fordCosts = value;
  }

  get sellerPrices(): PriceDropdownOption[] {
    return this.filterPricesByCountry(this._sellerPrices);
  }
  set sellerPrices(value: PriceDropdownOption[]) {
    this._sellerPrices = value;
  }


  constructor(
    private priceService: PriceService,
    private translateService: TranslateService,
    private messageService: MessageService,
    private router: Router,
    private productService: ProductService,
    private coverageService: CoverageService,
    private productPolicyService: ProductPolicyService,
    private apsPermissionService: ApsPermissionService,
    private route: ActivatedRoute,
    private vinService: VinService,
    private countryName: CountryName,
    private onlyAcceptNumbers: OnlyAcceptNumbers

  ) { }

  ngOnInit() {

    this.route.paramMap.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(params => {
      const id = params.get('id');
      this.id = id ? +id : 0;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.buttonCancel();
    }, 0);
  }

  // Phase 1 Search Methods
  searchProducts(event: AutoCompleteCompleteEvent): void {
    const query = (event.query || '').toLowerCase();
    const filtered = this.allProductArray.filter(item =>
      item.label.toLowerCase().includes(query)
    );
    this.productArray = filtered;
  }

  searchCoverages(event: AutoCompleteCompleteEvent): void {
    const query = (event.query || '').toLowerCase();
    const filtered = this.allCoveragesConcat.filter(item =>
      item.label.toLowerCase().includes(query)
    );
    this.coveragesConcat = filtered;
  }

  searchVehicleLines(event: AutoCompleteCompleteEvent): void {
    const query = (event.query || '').toLowerCase();
    const filtered = this.allVehicleLineConcat.filter(item =>
      item.label.toLowerCase().includes(query)
    );
    this.vehicleLineConcat = filtered;
  }

  // Phase 2 Search Methods with Intelligent Search
  private normalizeForSearch(label: string, query: string): boolean {
    // Intelligent search that handles currency formatting
    // Allows user to search by: just numbers, currency symbol, or full formatted value

    const queryTrimmed = query.trim();

    // If empty query, show all
    if (!queryTrimmed) {
      return true;
    }

    const labelLower = label.toLowerCase();

    // Detect if user is searching by currency (starts with R$ or $)
    const queryStartsWithCurrency = queryTrimmed.startsWith('R$') || queryTrimmed.startsWith('$');
    const labelStartsWithCurrency = labelLower.startsWith('R$') || labelLower.startsWith('$');

    // If user specified a currency, only match that currency
    if (queryStartsWithCurrency) {
      if (!labelStartsWithCurrency) return false;
      // Both have currency, compare the formatted string
      return labelLower.includes(queryTrimmed.toLowerCase());
    }

    // If user is just typing numbers, extract numbers from both and compare
    const queryOnlyNumbers = queryTrimmed.replace(/[^\d,.]/g, '');
    const labelOnlyNumbers = label.replace(/[^\d,.]/g, '');

    // Normalize decimal separators (treat both . and , as decimal)
    const queryNormalized = queryOnlyNumbers.replace(/[,.]/g, '');
    const labelNormalized = labelOnlyNumbers.replace(/[,.]/g, '');

    // Match if query numbers are contained in label numbers
    return labelNormalized.includes(queryNormalized);
  }

  searchWarrantyCosts(event: AutoCompleteCompleteEvent): void {
    const query = event.query || '';
    const filtered = this.allWarrantyPricesConcat.filter(item =>
      this.normalizeForSearch(item.label || '', query)
    );
    this.warrantyCosts = filtered;
  }

  searchServiceCosts(event: AutoCompleteCompleteEvent): void {
    const query = event.query || '';
    const filtered = this.allServiceCostPricesConcat.filter(item =>
      this.normalizeForSearch(item.label || '', query)
    );
    this.serviceCosts = filtered;
  }

  searchFordCosts(event: AutoCompleteCompleteEvent): void {
    const query = event.query || '';
    const filtered = this.allFordCostPricesConcat.filter(item =>
      this.normalizeForSearch(item.label || '', query)
    );
    this.fordCosts = filtered;
  }

  searchSellerPrices(event: AutoCompleteCompleteEvent): void {
    const query = event.query || '';
    const filtered = this.allSellerPricePricesConcat.filter(item =>
      this.normalizeForSearch(item.label || '', query)
    );
    this.sellerPrices = filtered;
  }

  searchCustomerPrices(event: AutoCompleteCompleteEvent): void {
    const query = event.query || '';
    const filtered = this.allCustomersPricesConcat.filter(item =>
      this.normalizeForSearch(item.label || '', query)
    );
    this.customersPricesConcat = filtered;
  }

  buttonReturn() {
    this.router.navigate(['view-plans'], { skipLocationChange: false, replaceUrl: false });
  }

  buttonEdit() {
    this.isEditingMode = true;
    this.hasAttemptedSave = false;
    this.clearValidationState();

    this.selectDisabled = false;
    (document.getElementById("monthsOffer") as HTMLInputElement).disabled = false;
    (document.getElementById("policyDescription") as HTMLInputElement).disabled = false;
    (document.getElementById("titleDetails") as HTMLInputElement).style.display = 'none';
    (document.getElementById("titleEdit") as HTMLInputElement).style.display = 'block';
    (document.getElementById("subTitle") as HTMLInputElement).style.display = 'block';
    this.getByCountryAndYear(this.productPolicy.country, this.productPolicy.modelYear);
  }

  buttonCancel() {
    this.isEditingMode = false;
    this.hasAttemptedSave = false;
    this.clearValidationState();

    this.getProductPolicyById();
    this.selectDisabled = true;
    (document.getElementById("titleDetails") as HTMLInputElement).style.display = 'block';
    (document.getElementById("titleEdit") as HTMLInputElement).style.display = 'none';
    (document.getElementById("subTitle") as HTMLInputElement).style.display = 'none';

    (document.getElementById("monthsOffer") as HTMLInputElement).disabled = true;
    (document.getElementById("policyDescription") as HTMLInputElement).disabled = true;
  }

  private clearValidationState() {
    this.inputMonthsOffer = undefined;
    this.inputPolicyDescription = undefined;
  }

  statusChange(event: DropdownChangeEvent<number | null>) {
    this.selectedStatus = typeof event.value === 'number' ? event.value : null;
  }

  private loadAllPrices(): void {

    this.priceService.getByCustomersPrices(getPriceNameList())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((dtos: PriceDto[]) => {

        const byName = dtos.reduce((acc, d) => {
          (acc[d.itemName] = acc[d.itemName] || []).push(d); return acc;
        }, {} as Record<string, PriceDto[]>);

        this.customersPricesConcat = this.toDropdown(byName[PriceName.PRICE_CUSTOMER]);
        this.warrantyCosts = this.toDropdown(byName[PriceName.COST_WARRANTY]);
        this.serviceCosts = this.toDropdown(byName[PriceName.COST_SERVICE]);
        this.fordCosts = this.toDropdown(byName[PriceName.COST_FORD]);
        this.sellerPrices = this.toDropdown(byName[PriceName.SELLER_PRICE]);

        // único placeholder “pre-seleccionado” que nos llega en la policy
        this.setCustomerPlaceholder();
        this.setFordCostPlaceholder();
        this.setWarrantyPlaceholder()
        this.setSellerPlaceholder();
        this.setCostServicePlaceholder();

        // Phase 2: Backup arrays for autocomplete price search
        this.allCustomersPricesConcat = [...this.customersPricesConcat];
        this.allWarrantyPricesConcat = [...this.warrantyCosts];
        this.allServiceCostPricesConcat = [...this.serviceCosts];
        this.allFordCostPricesConcat = [...this.fordCosts];
        this.allSellerPricePricesConcat = [...this.sellerPrices];

        // Initialize price selections with complete objects (not just IDs)
        this.initializePriceSelections();

      });
  }

  private initializePriceSelections(): void {

    if (this.idCustomerPrice) {
      this.selectedCustomerPrice = this.customersPricesConcat.find(p => Number(p.id) === Number(this.idCustomerPrice)) || null;
    }
    if (this.idCostWarranty) {
      this.selectedWarrantyCost = this.warrantyCosts.find(p => Number(p.id) === Number(this.idCostWarranty)) || null;
    }
    if (this.idCostService) {
      this.selectedServiceCost = this.serviceCosts.find(p => Number(p.id) === Number(this.idCostService)) || null;
    }
    if (this.idFordCost) {
      this.selectedFordCostPrice = this.fordCosts.find(p => Number(p.id) === Number(this.idFordCost)) || null;
    }
    if (this.idSellerPrice) {
      this.selectedSellerPrice = this.sellerPrices.find(p => Number(p.id) === Number(this.idSellerPrice)) || null;
    }
  }

  private toDropdown(list: PriceDto[] = []): PriceDropdownOption[] {
    return list.map(p => {
      const label = p.itemPriceUnit === ConstantsFordProtect.REAL
        ? p.itemPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : p.itemPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

      return {
        label,                 // lo que ve el usuario
        id: Number(p.id),      // value interno que compara ngModel
        itemPriceUnit: p.itemPriceUnit
      };
    });
  }

  private setCustomerPlaceholder(): void {
    const found = this.customersPricesConcat
      .find(o => Number(o.id) === Number(this.productPolicy.customerPriceId));
    if (found) {
      this.placeholderCustomerPrice = found.label;
    } else {
      this.placeholderCustomerPrice = 'TRANSLATE.SELECT';
    }
  }

  private setWarrantyPlaceholder(): void {
    const found = this.warrantyCosts
      .find(o => Number(o.id) === Number(this.productPolicy.warrantyCostId));
    if (found) {
      this.placeholderWarranty = found.label;
    } else {
      this.placeholderWarranty = 'TRANSLATE.SELECT';
    }
  }

  private setSellerPlaceholder(): void {
    const found = this.sellerPrices
      .find(o => Number(o.id) === Number(this.productPolicy.sellerPriceId));
    if (found) {
      this.placeholderSeller = found.label;
    } else {
      this.placeholderSeller = 'TRANSLATE.SELECT';
    }
  }

  private setFordCostPlaceholder(): void {
    const found = this.fordCosts
      .find(o => Number(o.id) === Number(this.productPolicy.fordCostId));
    if (found) {
      this.placeholderFordCost = found.label;
    } else {
      this.placeholderFordCost = 'TRANSLATE.SELECT';
    }
  }

  private setCostServicePlaceholder(): void {
    const found = this.serviceCosts
      .find(o => Number(o.id) === Number(this.productPolicy.serviceCostId));
    if (found) {
      this.placeholderServiceCost = found.label;
    } else {
      this.placeholderServiceCost = 'TRANSLATE.SELECT';
    }
  }

  private extractOptionId(value: DropdownSelection): number | null {
    if (value === null) {
      return null;
    }

    if (typeof value === 'number') {
      return value;
    }

    return value.id;
  }

  private isDropdownOption(value: DropdownSelection): value is DropdownOption {
    return value !== null && typeof value === 'object' && 'id' in value;
  }

  private hasMissingPriceSelection(value: DropdownSelection | undefined): boolean {
    if (value === undefined) {
      return true;
    }

    return this.toPositiveId(this.extractOptionId(value)) === null;
  }

  get showSellerPriceError(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.hasMissingPriceSelection(this.selectedSellerPrice);
  }

  get showCustomerPriceError(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.hasMissingPriceSelection(this.selectedCustomerPrice);
  }

  private toPositiveId(value: unknown): number | null {
    if (value === null || value === undefined) {
      return null;
    }

    const normalized = typeof value === 'string' ? Number(value.trim()) : Number(value);
    return Number.isFinite(normalized) && normalized > 0 ? normalized : null;
  }

  private resolvePriceId(currentValue: unknown, fallbackValues: unknown[]): number | null {
    const currentId = this.toPositiveId(currentValue);
    if (currentId !== null) {
      return currentId;
    }

    for (const value of fallbackValues) {
      const fallbackId = this.toPositiveId(value);
      if (fallbackId !== null) {
        return fallbackId;
      }
    }

    return null;
  }

  customerPriceChange(event: DropdownChangeEvent<DropdownSelection>) {
    this.selectedCustomerPrice = this.isDropdownOption(event.value) ? event.value : null;
    this.idCustomerPrice = this.extractOptionId(this.selectedCustomerPrice);
  }

  yearVehicleChange(event: DropdownChangeEvent<number | null>) {
    this.selectedYear = typeof event.value === 'number' ? event.value : null;
    this.year = this.selectedYear ?? 0;
    this.getByCountryAndYear(this.productPolicy.country, this.year)
  }

  vehicleLineChange(event: DropdownChangeEvent<DropdownOption | null>) {
    this.selectedVehicleLine = (event.value && 'id' in event.value && event.value.id) ? event.value : null;
    this.idVehicle = this.selectedVehicleLine?.id ?? 0;
  }

  canalVendasChange(event: DropdownChangeEvent<number | null>) {
    this.selectCanalVenda = typeof event.value === 'number' ? event.value.toString() : '';
    this.selectedSalesChannel = typeof event.value === 'number' ? event.value : null;
  }

  monthsOffer(monthsOffer: Event) {

    this.inputMonthsOffer = this.onlyAcceptNumbers
      .formatNumber(monthsOffer);
  }

  getByCountryAndYear(country: string, year: number) {

    this.vinService
      .getByCountryAndYear(country, year)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: VinCategory[]) => {

        this.vehicleLines = response;

        this.vehicleLineConcat = this.vehicleLines.map(object => {
          const option = {
            label: `${object.vehicleLine} - ${object.vehicleLineCode} - ${object.tmaCode}${object.versionCode !== null ? ' - ' + object.versionCode + '.' : '.'}`,
            id: object.idVinCategoryVersion
          };

          if (Number(object.idVinCategoryVersion) === Number(this.productPolicy.vinCategoryVersionId)) {
            this.idVehicle = object.idVinCategoryVersion;
            this.placeholderVehicle = option.label;
            this.selectedVehicleLine = option;
          }

          return option;
        });

        // Phase 1: Backup array for autocomplete search
        this.allVehicleLineConcat = [...this.vehicleLineConcat];
      }, (err) => {

        this.blockedUi = false;

        if (err.status === 400) {
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.COVERAGE.NOT.FOUND')
          });
        } else if (err.status === 401) {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
          });

        } else {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
          });
        }

      });
  }

  getProducts(country: string, productId: number) {

    this.productService
      .getProductsByCountryForProductPolicies(country)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: ProductVisit[]) => {

        this.products = response;

        this.productArray = this.products.map(object => {
          const option = {
            id: object.productId,
            label: object.productName
          };

          if (object.productId === productId) {
            this.placeholderProduct = object.productName;
            this.idProduct = object.productId;
            this.selectedProducts = option;
          }

          return option;
        });

        // Phase 1: Backup array for autocomplete search
        this.allProductArray = [...this.productArray];

      }, (err) => {

        if (err.status === 400) {
          this.blockedUi = false;
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.PRODUCTS.NOT.FOUND')
          });
        } else if (err.status === 401) {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
          });

        } else {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
          });
        }

      });

  }

  addSelectOption() {
    const selectOption = { id: null, label: this.translateService.instant('TRANSLATE.SELECT') };
    if (!this.productArray.some((option) => option.label === this.translateService.instant('TRANSLATE.SELECT'))) {
      this.productArray = [selectOption, ...this.productArray];
    }
  }

  coverageChange(event: DropdownChangeEvent<DropdownOption | null>) {
    this.selectedCoverages = (event.value && 'id' in event.value && event.value.id) ? event.value : null;
    this.idCoverage = this.selectedCoverages?.id ?? 0;
  }

  productChange(event: DropdownChangeEvent<DropdownOption | null>) {
    this.selectedProducts = (event.value && 'id' in event.value && event.value.id) ? event.value : null;
    this.idProduct = this.selectedProducts?.id ?? 0;
    this.getSearchByProductId(this.idProduct, this.coverageCategoryId);
  }

  getSearchByProductId(idProduct: number, coverageCategoryId: number) {

    this.coverageService
      .getSearchByProductId(idProduct)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: CoverageCategory[]) => {

        this.coverages = response;

        this.coveragesConcat = this.coverages.map(object => {
          const option = {
            label: `${object.visit} Visitas - ${object.term} Meses ${object.distance !== null ? ' - ' + object.distance + ' Km.' : '.'}`,
            id: object.id
          };

          if (object.id === coverageCategoryId) {
            this.placeholderCoverage = option.label;
            this.idCoverage = object.id;
            this.selectedCoverages = option;
          }

          return option;
        });

        // Phase 1: Backup array for autocomplete search
        this.allCoveragesConcat = [...this.coveragesConcat];

        this.blockedUi = false;
      }, (err) => {

        if (err.status === 400) {
          this.blockedUi = false;
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.COVERAGE.NOT.FOUND')
          });
        } else if (err.status === 401) {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
          });

        } else {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
          });
        }

      });

  }

  getProductPolicyById() {

    this.blockedUi = true;

    this.productPolicyService.getById(this.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {

          this.productPolicy = response;

          this.getProducts(response.country, response.productId);
          this.loadAllPrices();
          this.getSearchByProductId(response.productId, response.coverageCategoryId);
          this.getByCountryAndYear(response.country, response.modelYear);
          this.coverageCategoryId = response.coverageCategoryId;
          this.selectedYear = this.productPolicy.modelYear;
          this.placeholderVehicle = `${response.vehicleLine} - ${response.vehicleLineCode} - ${response.tmaCode}${response.versionCode !== null ? ' - ' + response.versionCode + '.' : '.'}`;
          this.selectedVehicleLine = {
            id: response.vinCategoryVersionId,
            label: this.placeholderVehicle
          };
          this.idVehicle = response.vinCategoryVersionId;
          this.selectCanalVenda = response.saleType.toString();
          this.selectedSalesChannel = response.saleType;
          this.countryNameResult = this.countryName.getCountryName(response.country);

          if (response.fordCostId === null) {
            this.placeholderFordCost = "TRANSLATE.SELECT";
          }
          if (response.serviceCostId === null) {
            this.placeholderServiceCost = "TRANSLATE.SELECT";
          }
          if (response.warrantyCostId === null) {
            this.placeholderWarranty = "TRANSLATE.SELECT";
          }
          if (response.customerPriceId === null) {
            this.placeholderCustomerPrice = "TRANSLATE.SELECT";
          }
          if (response.sellerPriceId === null) {
            this.placeholderSeller = "TRANSLATE.SELECT";
          }
          // Store IDs temporarily - actual initialization happens in loadAllPrices() after arrays are populated
          this.idCustomerPrice = response.customerPriceId ? Number(response.customerPriceId) : null;
          this.idCostService = response.serviceCostId ? Number(response.serviceCostId) : null;
          this.idFordCost = response.fordCostId ? Number(response.fordCostId) : null;
          this.idCostWarranty = response.warrantyCostId ? Number(response.warrantyCostId) : null;
          this.idSellerPrice = response.sellerPriceId ? Number(response.sellerPriceId) : null;

          if (response.isActive === 1) {
            this.selectedStatus = ConstantsFordProtect.COVERAGE_ACTIVE.valueOf();
          }
          else if (response.isActive === 0) {
            this.selectedStatus = ConstantsFordProtect.COVERAGE_INACTIVE.valueOf();
          }

        },
        error: (err) => {

          this.blockedUi = false;
          const editButton = document.getElementById('btnEdit') as HTMLButtonElement;
          if (editButton) {
            editButton.disabled = true;
          }

          if (err === 400) {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.ELEGIBILITY.NOT.FOUND')
            });
          } else if (err.status === 401) {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
            });

          } else {

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('TRANSLATE.ERROR'),
              detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
            });
          }

        }
      });
  }

  warrantyCostChange(event: DropdownChangeEvent<DropdownSelection>) {
    this.selectedWarrantyCost = this.isDropdownOption(event.value) ? event.value : null;
    this.idCostWarranty = this.extractOptionId(this.selectedWarrantyCost);
  }

  serviceCostChange(event: DropdownChangeEvent<DropdownSelection>) {
    this.selectedServiceCost = this.isDropdownOption(event.value) ? event.value : null;
    this.idCostService = this.extractOptionId(this.selectedServiceCost);
  }

  fordCostChange(event: DropdownChangeEvent<DropdownSelection>) {
    this.selectedFordCostPrice = this.isDropdownOption(event.value) ? event.value : null;
    this.idFordCost = this.extractOptionId(this.selectedFordCostPrice);
  }

  sellerPriceChange(event: DropdownChangeEvent<DropdownSelection>) {
    this.selectedSellerPrice = this.isDropdownOption(event.value) ? event.value : null;
    this.idSellerPrice = this.extractOptionId(this.selectedSellerPrice);
  }

  buttonSave() {

    this.hasAttemptedSave = true;

    this.blockedUi = true;

    // Normalize and validate all required fields
    if (this.inputMonthsOffer === undefined) {
      this.inputMonthsOffer = parseInt((document.getElementById("monthsOffer") as HTMLInputElement).value);
    }
    this.inputPolicyDescription = (this.productPolicy.policyDescription ?? '').toString();
    if (this.inputMonthsOffer !== null && this.inputMonthsOffer !== undefined && (this.inputMonthsOffer <= 0 || isNaN(this.inputMonthsOffer))) {
      this.inputMonthsOffer = null;
    }
    if (this.selectedStatus === undefined) {
      this.selectedStatus = null;
    }
    if (this.selectedCustomerPrice === undefined) {
      this.selectedCustomerPrice = null;
    }
    if (this.selectedCoverages === undefined) {
      this.selectedCoverages = null;
    }
    if (this.selectedProducts === undefined) {
      this.selectedProducts = null;
    }
    if (this.selectedVehicleLine === undefined && this.placeholderVehicle === null) {
      this.selectedVehicleLine = null;
    }
    if (this.selectedWarrantyCost === undefined || this.selectedWarrantyCost === null) {
      this.selectedWarrantyCost = null;
    }
    if (this.selectedServiceCost === undefined || this.selectedServiceCost === null) {
      this.selectedServiceCost = null;
    }
    if (this.selectedFordCostPrice === undefined || this.selectedFordCostPrice === null) {
      this.selectedFordCostPrice = null;
    }
    if (this.selectedSellerPrice === undefined || this.selectedSellerPrice === null) {
      this.selectedSellerPrice = null;
    }
    if (this.selectedSalesChannel === undefined) {
      this.selectedSalesChannel = null;
    }
    if (this.selectedYear === undefined) {
      this.selectedYear = null;
    }

    // Validate mandatory fields BEFORE resolving with fallback values.
    // This ensures users must explicitly select required fields, not just rely on old values.
    const hasCustomerPriceError = this.selectedCustomerPrice === null;
    const hasSellerPriceError = this.selectedSellerPrice === null;

    // Keep existing ids when user does not change dropdown values and guard against NaN/undefined.
    const policyAny = this.productPolicy as ProductPolicyEditDto & Record<string, unknown>;
    this.idCustomerPrice = this.resolvePriceId(this.idCustomerPrice, [policyAny.customerPriceId, policyAny.itemPriceCustomerId]);
    this.idCostService = this.resolvePriceId(this.idCostService, [policyAny.serviceCostId, policyAny.costServiceId, policyAny.itemPriceServiceId]);
    this.idFordCost = this.resolvePriceId(this.idFordCost, [policyAny.fordCostId, policyAny.fordCostPriceId, policyAny.itemPriceFordCostId]);
    this.idCostWarranty = this.resolvePriceId(this.idCostWarranty, [policyAny.warrantyCostId, policyAny.warrantyPriceId, policyAny.itemPriceWarrantyId]);
    this.idSellerPrice = this.resolvePriceId(this.idSellerPrice, [policyAny.sellerPriceId, policyAny.itemPriceSellerId]);

    // Validate all required fields before proceeding
    // Note: Warranty Cost, Service Cost, and Ford Cost are now optional
    const isValid =
      this.inputMonthsOffer !== null &&
      this.selectedStatus !== null &&
      !hasCustomerPriceError &&
      !hasSellerPriceError &&
      this.selectedCoverages !== null &&
      this.selectedProducts !== null &&
      (this.selectedVehicleLine !== null || this.placeholderVehicle !== null) &&
      this.selectedSalesChannel !== null &&
      this.selectedYear !== null;

    if (isValid) {
      this.editedProductPolicy.productPolicyId = this.id;
      this.editedProductPolicy.coverageCategoryId = this.idCoverage;
      this.editedProductPolicy.productId = this.idProduct;
      this.editedProductPolicy.vinCategoryVersionId = this.idVehicle;
      this.editedProductPolicy.country = this.productPolicy.country;
      this.editedProductPolicy.user = sessionStorage.getItem('userId') as string;
      this.editedProductPolicy.saleType = parseInt(this.selectCanalVenda, 10);
      const customerPriceId = this.idCustomerPrice as number;
      const fordCostId = this.idFordCost as number;
      const serviceCostId = this.idCostService as number;
      const warrantyCostId = this.idCostWarranty as number;
      const sellerPriceId = this.idSellerPrice as number;

      this.editedProductPolicy.customerPriceId = customerPriceId;
      this.editedProductPolicy.fordCostId = fordCostId;
      this.editedProductPolicy.serviceCostId = serviceCostId;
      this.editedProductPolicy.warrantyCostId = warrantyCostId;
      this.editedProductPolicy.sellerPriceId = sellerPriceId;
      this.editedProductPolicy.months = this.inputMonthsOffer as number;
      this.editedProductPolicy.isActive = this.selectedStatus as number;
      this.editedProductPolicy.modelYear = this.selectedYear as number;
      this.editedProductPolicy.policyDescription = this.inputPolicyDescription;

      const updatePayload: ProductPolicyEditDto & Record<string, unknown> = {
        ...this.editedProductPolicy,
        // Backward/compat aliases used by some backend DTO mappings.
        // Names from create request DTO
        fordCostPriceId: fordCostId,
        costServiceId: serviceCostId,
        warrantyPriceId: warrantyCostId,
        // Names observed in response DTO / legacy backend mappers
        itemPriceCustomerId: customerPriceId,
        itemPriceFordCostId: fordCostId,
        itemPriceServiceId: serviceCostId,
        itemPriceWarrantyId: warrantyCostId,
        itemPriceSellerId: sellerPriceId,
        // Additional compatibility names used by some gateway/mapping layers.
        servicePriceId: serviceCostId,
        fordPriceId: fordCostId,
        warrantyCostPriceId: warrantyCostId,
        // Object-shaped aliases used by some backend update DTOs.
        itemPriceCustomer: { id: customerPriceId },
        itemPriceFordCost: { id: fordCostId },
        itemPriceService: { id: serviceCostId },
        itemPriceWarranty: { id: warrantyCostId },
        itemPriceSeller: { id: sellerPriceId }
      };

      console.log('Eligibility update payload:', updatePayload);

      this.productPolicyService.updateProductPolicy(updatePayload)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {

            this.blockedUi = false;
            this.buttonCancel();

            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('TRANSLATE.SUCCESS'),
              detail: this.translateService.instant('TRANSLATE.SUCCESS.EDIT')
            });

          }, error: (err) => {

            this.blockedUi = false;

            if (err.status === 400) {
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.ERROR.PLEASE.REQUIRED.FIELDS')
              });

            } else if (err.status === 404) {
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.ERROR.SAVE.CHANGES')
              });

            } else if (err.status === 401) {
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
              });

            } else {
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
              });
            }
          }

        });
    } else {
      this.blockedUi = false;
      this.focusFirstInvalidField();
      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('TRANSLATE.ERROR'),
        detail: this.translateService.instant('TRANSLATE.ERROR.PLEASE.REQUIRED.FIELDS')
      });
    }

  }

  restoringValues() {
    this.selectedStatus = null;
    this.selectedSalesChannel = null;
    this.selectedCountry = '';
    this.selectedVehicleLine = null;
    this.selectedWarrantyCost = null;
    this.selectedServiceCost = null;
    this.selectedFordCostPrice = null;
    this.selectedSellerPrice = null;
    this.inputMonthsOffer = null;
    this.inputPolicyDescription = '';
  }

  private focusFirstInvalidField(): void {
    if (this.selectedProducts === null) {
      this.focusFieldById('productIdName');
      return;
    }

    if (this.selectedCoverages === null) {
      this.focusFieldById('coverageName');
      return;
    }

    if (this.selectedSalesChannel === null) {
      this.focusFieldById('salesChannel');
      return;
    }

    if (this.selectedStatus === null) {
      this.focusFieldById('status');
      return;
    }

    if (this.selectedYear === null) {
      this.focusFieldById('yearVehicle');
      return;
    }

    if (this.selectedVehicleLine === null && this.placeholderVehicle === null) {
      this.focusFieldById('vehicle');
      return;
    }

    if (this.inputMonthsOffer === null) {
      this.focusFieldById('monthsOffer');
      return;
    }

    // Warranty Cost, Service Cost, and Ford Cost are now optional fields

    if (this.hasMissingPriceSelection(this.selectedSellerPrice)) {
      this.focusFieldById('sellerPrice');
      return;
    }

    if (this.hasMissingPriceSelection(this.selectedCustomerPrice)) {
      this.focusFieldById('customerPrice');
    }
  }

  private focusFieldById(elementId: string): void {
    setTimeout(() => {
      const host = document.getElementById(elementId) as HTMLElement | null;
      if (!host) {
        return;
      }

      const focusableChild = host.querySelector('input, textarea, .p-dropdown-label, .p-multiselect-label, [tabindex]') as HTMLElement | null;
      const target = focusableChild ?? host;

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.focus();
    }, 0);
  }

}
